var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStyleflasherWatermark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 428.72,
    height: 31.992,
    viewBox: "0 0 428.72 31.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "styleflasher__Wasserzeichen",
    "data-name": "styleflasher_ Wasserzeichen",
    transform: "translate(-61.994 -3164.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "styleflasher_logo_black_animated",
    transform: "translate(61.994 3164.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M7.809,17.229v.157a3.062,3.062,0,0,0,1.05,2.5,6.15,6.15,0,0,0,3.7.876,6.989,6.989,0,0,0,3.13-.492,2.277,2.277,0,0,0,1.4-2.12,2.086,2.086,0,0,0-1.619-1.992,14.126,14.126,0,0,0-3.162-.7l-3.586-.6a12.353,12.353,0,0,1-7.06-2.538A5.526,5.526,0,0,1,.117,8.239,7.009,7.009,0,0,1,3.662,1.734a16.505,16.505,0,0,1,8.5-1.707,16.314,16.314,0,0,1,8.463,1.687,6.289,6.289,0,0,1,3.4,6.11H16.442a2.157,2.157,0,0,0-1.263-2.177,6.946,6.946,0,0,0-3.159-.5,6.508,6.508,0,0,0-2.948.529A1.992,1.992,0,0,0,7.877,7.5c0,1.224,1.05,1.579,1.687,1.753a34.962,34.962,0,0,0,3.759.7l3.056.452a13.728,13.728,0,0,1,6.454,2.14,6.349,6.349,0,0,1,2.459,5.339,7.257,7.257,0,0,1-2.914,6.081A16.22,16.22,0,0,1,12.817,26a15.629,15.629,0,0,1-10.244-2.5A7.4,7.4,0,0,1,.011,17.385v-.142Z",
    transform: "translate(0.006 0.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M44.03,6.628V.88H68.3V6.628H60.077V25.464h-7.8V6.628Z",
    transform: "translate(-10.718 -0.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M106.291.88h8.423L104.43,16.472v8.992h-7.8V16.472L86.38.88h9.058l5.475,10.042Z",
    transform: "translate(-21.043 -0.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M156.392,25.464H135.71V.88h7.8V19.491h12.885Z",
    transform: "translate(-33.071 -0.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M196.914,10.362V15.7H184.109v4h15.936v5.763H176.3V.88h23.352V6.628H184.1v3.734Z",
    transform: "translate(-42.968 -0.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M241.411,10.922v5.339H229.647v9.2h-7.8V.88h22.481V6.628H229.647v4.3h11.767Z",
    transform: "translate(-54.073 -0.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M285.688,25.464H265V.88h7.8V19.491h12.885v5.976Z",
    transform: "translate(-64.595 -0.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M310.729,25.464h-7.968L313.714.88h7.4l10.919,24.584h-7.968l-1.724-4.249h-9.869Zm9.869-9.058L317.385,8.29l-3.13,8.113Z",
    transform: "translate(-73.799 -0.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M359.188,17.229v.157a3.062,3.062,0,0,0,1.05,2.5,6.15,6.15,0,0,0,3.7.876,7.009,7.009,0,0,0,3.13-.492,2.276,2.276,0,0,0,1.406-2.109,2.086,2.086,0,0,0-1.619-1.992,14.124,14.124,0,0,0-3.162-.7l-3.586-.6a12.353,12.353,0,0,1-7.054-2.527,5.526,5.526,0,0,1-1.542-4.075,7.009,7.009,0,0,1,3.534-6.528,16.5,16.5,0,0,1,8.5-1.707A16.317,16.317,0,0,1,372,1.714a6.289,6.289,0,0,1,3.415,6.11h-7.584a2.157,2.157,0,0,0-1.263-2.177,6.921,6.921,0,0,0-3.173-.5,6.508,6.508,0,0,0-2.948.529,1.992,1.992,0,0,0-1.2,1.821c0,1.224,1.05,1.579,1.687,1.753a34.964,34.964,0,0,0,3.759.7l3.056.452a13.727,13.727,0,0,1,6.457,2.14,6.349,6.349,0,0,1,2.459,5.338,7.257,7.257,0,0,1-2.911,6.073,16.221,16.221,0,0,1-9.55,2.035,15.628,15.628,0,0,1-10.245-2.5,7.431,7.431,0,0,1-2.561-6.147v-.137h7.8Z",
    transform: "translate(-85.657 0.014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M407.017,25.464h-7.8V.88h7.8V9.659h10.111V.88h7.8V25.464h-7.8V15.421H407.017Z",
    transform: "translate(-97.318 -0.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M470.094,10.362V15.7H457.289v4h15.936v5.763H449.48V.88h23.352V6.628H457.277v3.734Z",
    transform: "translate(-109.573 -0.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M495.039.908h15.936a10.557,10.557,0,0,1,6.639,1.619,6.409,6.409,0,0,1,2.459,5.444,5.906,5.906,0,0,1-1.542,4.288,7.231,7.231,0,0,1-3.13,1.753v.142a4.738,4.738,0,0,1,2.911,1.511,5.864,5.864,0,0,1,1.224,3.864l.142,2.39a6.168,6.168,0,0,0,1.022,3.586h-8.085a4.821,4.821,0,0,1-.982-3.093l-.105-1.753a4.052,4.052,0,0,0-1.09-3.093,5.643,5.643,0,0,0-3.2-.808h-4.411V25.5h-7.8V.908Zm7.8,10.851H508.6a5.433,5.433,0,0,0,2.738-.6,2.641,2.641,0,0,0,1.022-2.245A2.3,2.3,0,0,0,511.2,6.739a5.259,5.259,0,0,0-2.669-.424h-5.691v5.444Z",
    transform: "translate(-120.679 -0.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M540.23,38.64h20.19v2.732H540.23Z",
    transform: "translate(-131.699 -9.38)",
    opacity: 0
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x2: 19.521,
    transform: "translate(469.975 3190.092)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleflasherWatermark);
export default __webpack_public_path__ + "static/media/styleflasher_watermark.33c39857a6cfd8b78f3f45d490dad0a2.svg";
export { ForwardRef as ReactComponent };